import { useAuthStore } from "@/stores/auth";
import { useVersionStore } from "@/stores/version";

const VERSION_CHECK_INTERVAL_MS = 60*1000; //60 seconds

export function startVersionCheck(currentVersion) {
  const versionStore = useVersionStore();
  const authStore = useAuthStore();
  setInterval(async () => {
    if (versionStore.newVersionAvailable) return;
    try {
      const response = await fetch('/version.json', { cache: 'no-store' });
      if (!response.ok) return;
      const data = await response.json();
      if (data?.version && data.version !== currentVersion) {
        console.log(`🔄 New version detected: ${data.version} (current: ${currentVersion}).`);
        if (authStore.isAuthenticated) {
          versionStore.markNewVersion(data.version);
        } else {
          window.location.reload();
        }
      }
    } catch {
      // ignore: network errors or missing file
    }
  }, VERSION_CHECK_INTERVAL_MS);
}
